"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PageHeader;
var _react = _interopRequireWildcard(require("react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon/icon"));
var _logo = _interopRequireDefault(require("../../assets/images/logo.svg"));
var _mobileLogo = _interopRequireDefault(require("../../assets/images/mobileLogo.svg"));
var _imageWrapper = _interopRequireDefault(require("../imageWrapper/imageWrapper"));
var _pageHeaderModule = _interopRequireDefault(require("./pageHeader.module.scss"));
var _useEnhancedHref = _interopRequireDefault(require("../../hooks/useEnhancedHref"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function PageHeader(props) {
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showNav = _useState2[0],
    setShowNav = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    activeGroup = _useState4[0],
    setActiveGroup = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    activeSubGroup = _useState6[0],
    setActiveSubGroup = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isTouchDevice = _useState8[0],
    setIsTouchDevice = _useState8[1];
  var containerRef = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);
  var navButtonRef = (0, _react.useRef)(null);
  var linkGroups = props.linkGroups;
  var topLevelRefs = {};
  var secondLevelRefs = {};
  linkGroups.forEach(function (group) {
    var _group$linkGroups;
    topLevelRefs[group.link.key] = (0, _react.useRef)(null);
    (_group$linkGroups = group.linkGroups) === null || _group$linkGroups === void 0 || _group$linkGroups.forEach(function (subgroup) {
      secondLevelRefs[subgroup.link.key] = (0, _react.useRef)(null);
    });
  });
  var toggleGroup = function toggleGroup(e, group) {
    if (isTouchDevice) {
      var _group$linkGroups2;
      if ((_group$linkGroups2 = group.linkGroups) !== null && _group$linkGroups2 !== void 0 && _group$linkGroups2.length && activeGroup !== group) {
        e.preventDefault();
        setActiveGroup(group);
        setActiveSubGroup(null);
      } else {
        resetNavState();
      }
    } else {
      return resetNavState();
    }
  };
  var toggleSubGroup = function toggleSubGroup(e, group) {
    if (isTouchDevice) {
      var _group$linkGroups3;
      if ((_group$linkGroups3 = group.linkGroups) !== null && _group$linkGroups3 !== void 0 && _group$linkGroups3.length && activeSubGroup !== group) {
        e.preventDefault();
        setActiveSubGroup(group);
      } else {
        resetNavState();
      }
    } else {
      resetNavState();
    }
  };
  var updateIsTouchDevice = function updateIsTouchDevice() {
    if (typeof window !== 'undefined') {
      var isSmallScreen = window.innerWidth < 769;
      var _isTouchDevice = document && document.documentElement ? document.documentElement.ontouchstart !== undefined : false;
      setIsTouchDevice(isSmallScreen || _isTouchDevice);
    }
  };
  var handleResize = (0, _debounce["default"])(function () {
    updateIsTouchDevice();
  });
  (0, _react.useEffect)(function () {
    updateIsTouchDevice();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var targetRef = topLevelRefs[activeGroup === null || activeGroup === void 0 ? void 0 : activeGroup.link.key];
    var targetHeight = targetRef !== null && targetRef !== void 0 && targetRef.current ? targetRef.current.offsetHeight : 0;
    if (activeSubGroup !== null && activeSubGroup !== void 0 && activeSubGroup.linkGroups) {
      var subGroupHeight = secondLevelRefs[activeSubGroup === null || activeSubGroup === void 0 ? void 0 : activeSubGroup.link.key].current.offsetHeight;
      if (subGroupHeight > targetHeight) {
        targetHeight = subGroupHeight;
      }
    }
    if (containerRef.current) {
      containerRef.current.style.maxHeight = "".concat(targetHeight + 48, "px");
    }
  }, [activeGroup, activeSubGroup]);
  var updateOrientation = function updateOrientation() {
    window.focus();
    resetNavState();
  };
  (0, _react.useEffect)(function () {
    window.addEventListener('orientationchange', updateOrientation);
    return function () {
      window.removeEventListener('orientationchange', updateOrientation);
    };
  }, []);
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (wrapperRef.current && navButtonRef.current && !wrapperRef.current.contains(event.target) && !navButtonRef.current.contains(event.target)) {
        resetNavState();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  var resetNavState = function resetNavState() {
    setShowNav(false);
    setActiveGroup(null);
    setActiveSubGroup(null);
  };
  var generateSupportLinks = function generateSupportLinks(links) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _pageHeaderModule["default"].supportLinks,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _pageHeaderModule["default"].supportTitle,
        children: "Customer Support"
      }), links.map(function (supportLink, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          onClick: function onClick() {
            return resetNavState();
          },
          children: supportLink.link.linkNode
        }, i);
      })]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isTouchDevice && showNav && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": "overlay",
      className: _pageHeaderModule["default"].overlay
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("header", {
      className: (0, _classnames["default"])(_pageHeaderModule["default"].header, _defineProperty(_defineProperty({}, _pageHeaderModule["default"].hasLogin, props.login), _pageHeaderModule["default"].hasNavigation, props.linkGroups.length > 0)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames["default"])(_pageHeaderModule["default"].header, _defineProperty({}, _pageHeaderModule["default"].open, showNav)),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _pageHeaderModule["default"].headerTop,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: (0, _useEnhancedHref["default"])('/'),
            className: _pageHeaderModule["default"].logo,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_imageWrapper["default"], {
              desktop: _logo["default"],
              tablet: _logo["default"],
              mobile: _mobileLogo["default"],
              altText: "John Lewis Money logo"
            })
          }), (props.login || linkGroups.length > 0) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _pageHeaderModule["default"].quickLinks,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
              children: [props.login && /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                className: _pageHeaderModule["default"].signIn,
                onClick: function onClick() {
                  return resetNavState();
                },
                children: props.login
              }), linkGroups.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                ref: navButtonRef,
                className: (0, _classnames["default"])(_pageHeaderModule["default"].mobileNavButton, _defineProperty({}, _pageHeaderModule["default"].open, showNav)),
                onClick: function onClick() {
                  setShowNav(!showNav);
                  setActiveGroup(null);
                  setActiveSubGroup(null);
                },
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: _pageHeaderModule["default"].top
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: _pageHeaderModule["default"].middle
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: _pageHeaderModule["default"].bottom
                  })]
                }), showNav ? 'Close' : 'Menu']
              })]
            })
          })]
        }), linkGroups.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)("nav", {
          className: (0, _classnames["default"])(_pageHeaderModule["default"].nav, _defineProperty(_defineProperty(_defineProperty({}, _pageHeaderModule["default"].open, showNav), _pageHeaderModule["default"].activeGroup, activeGroup), _pageHeaderModule["default"].activeSubGroup, activeSubGroup)),
          onMouseLeave: function onMouseLeave() {
            return !isTouchDevice && resetNavState();
          },
          ref: wrapperRef,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classnames["default"])(_pageHeaderModule["default"].listContain, _pageHeaderModule["default"].open),
            ref: containerRef,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
              children: linkGroups.map(function (topLevelGroup, i) {
                var _topLevelGroup$linkGr, _topLevelGroup$linkGr2, _topLevelGroup$linkGr3, _topLevelGroup$linkGr4;
                return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
                  className: (0, _classnames["default"])(_pageHeaderModule["default"].topLevel, _defineProperty(_defineProperty({}, _pageHeaderModule["default"].hidden, activeGroup), _pageHeaderModule["default"].active, topLevelGroup === activeGroup)),
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: _pageHeaderModule["default"].link,
                    onClick: function onClick(e) {
                      return toggleGroup(e, topLevelGroup);
                    },
                    onFocus: function onFocus() {
                      return !isTouchDevice && setActiveGroup(topLevelGroup);
                    },
                    onMouseOver: function onMouseOver() {
                      return !isTouchDevice && setActiveGroup(topLevelGroup);
                    },
                    children: [topLevelGroup.link.linkNode, ((_topLevelGroup$linkGr = topLevelGroup.linkGroups) === null || _topLevelGroup$linkGr === void 0 ? void 0 : _topLevelGroup$linkGr.length) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
                      name: "chevron-right"
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    className: (0, _classnames["default"])(_pageHeaderModule["default"].subNavWrapper, _defineProperty({}, _pageHeaderModule["default"].open, topLevelGroup === activeGroup && ((_topLevelGroup$linkGr2 = topLevelGroup.linkGroups) === null || _topLevelGroup$linkGr2 === void 0 ? void 0 : _topLevelGroup$linkGr2.length))),
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: _pageHeaderModule["default"].subNavContain,
                      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
                        className: (0, _classnames["default"])(_pageHeaderModule["default"].subNav, _defineProperty({}, _pageHeaderModule["default"].open, topLevelGroup === activeGroup && ((_topLevelGroup$linkGr3 = topLevelGroup.linkGroups) === null || _topLevelGroup$linkGr3 === void 0 ? void 0 : _topLevelGroup$linkGr3.length))),
                        ref: topLevelRefs[topLevelGroup.link.key],
                        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                          className: _pageHeaderModule["default"].secondLevel,
                          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                            className: (0, _classnames["default"])(_pageHeaderModule["default"].mobileTitle, _defineProperty({}, _pageHeaderModule["default"].hidden, activeSubGroup)),
                            onClick: function onClick() {
                              setActiveGroup(null);
                            },
                            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
                              name: "chevron-left"
                            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                              className: _pageHeaderModule["default"].title,
                              children: topLevelGroup === null || topLevelGroup === void 0 ? void 0 : topLevelGroup.link.key
                            })]
                          }), topLevelGroup === null || topLevelGroup === void 0 || (_topLevelGroup$linkGr4 = topLevelGroup.linkGroups) === null || _topLevelGroup$linkGr4 === void 0 ? void 0 : _topLevelGroup$linkGr4.map(function (secondLevelGroup, i) {
                            var _secondLevelGroup$lin, _activeSubGroup$linkG, _activeSubGroup$linkG2;
                            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                                className: (0, _classnames["default"])(_defineProperty({}, _pageHeaderModule["default"].hidden, activeSubGroup)),
                                children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                                  onClick: function onClick(e) {
                                    toggleSubGroup(e, secondLevelGroup);
                                  },
                                  onFocus: function onFocus() {
                                    return !isTouchDevice && setActiveSubGroup(secondLevelGroup);
                                  },
                                  onMouseOver: function onMouseOver() {
                                    return !isTouchDevice && setActiveSubGroup(secondLevelGroup);
                                  },
                                  className: _pageHeaderModule["default"].link,
                                  children: [secondLevelGroup.link.linkNode, ((_secondLevelGroup$lin = secondLevelGroup.linkGroups) === null || _secondLevelGroup$lin === void 0 ? void 0 : _secondLevelGroup$lin.length) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
                                    name: "chevron-right"
                                  })]
                                })
                              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
                                ref: secondLevelRefs[secondLevelGroup.link.key],
                                className: (0, _classnames["default"])(_pageHeaderModule["default"].subNav, _pageHeaderModule["default"].thirdLevel, _defineProperty({}, _pageHeaderModule["default"].open, activeSubGroup && activeSubGroup === secondLevelGroup && ((_activeSubGroup$linkG = activeSubGroup.linkGroups) === null || _activeSubGroup$linkG === void 0 ? void 0 : _activeSubGroup$linkG.length))),
                                children: [(secondLevelGroup === null || secondLevelGroup === void 0 ? void 0 : secondLevelGroup.linkGroups) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                                    className: _pageHeaderModule["default"].mobileTitle,
                                    onClick: function onClick() {
                                      return setActiveSubGroup(null);
                                    },
                                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icon["default"], {
                                      name: "chevron-left",
                                      ariaLabel: "nav-back-two"
                                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                                      className: _pageHeaderModule["default"].title,
                                      children: secondLevelGroup === null || secondLevelGroup === void 0 ? void 0 : secondLevelGroup.link.key
                                    })]
                                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                                    className: _pageHeaderModule["default"].activeSubGroup,
                                    children: activeSubGroup === null || activeSubGroup === void 0 || (_activeSubGroup$linkG2 = activeSubGroup.linkGroups) === null || _activeSubGroup$linkG2 === void 0 ? void 0 : _activeSubGroup$linkG2.map(function (thirdLevelGroup, i) {
                                      return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                                        onClick: function onClick() {
                                          resetNavState();
                                        },
                                        children: thirdLevelGroup.link.linkNode
                                      }, i);
                                    })
                                  })]
                                }), (secondLevelGroup === null || secondLevelGroup === void 0 ? void 0 : secondLevelGroup.customerSupportLinks) && generateSupportLinks(secondLevelGroup.customerSupportLinks)]
                              })]
                            }, i);
                          })]
                        }), (topLevelGroup === null || topLevelGroup === void 0 ? void 0 : topLevelGroup.customerSupportLinks) && generateSupportLinks(topLevelGroup.customerSupportLinks)]
                      })
                    })
                  })]
                }, i);
              })
            })
          })
        })]
      })
    })]
  });
}